enum WebserviceConverterFields {
	ENABLED = "converter_enabled",
	INSTANCES = "converter_instances",
	QUEUE = "converter_queue",
	LATENCY = "converter_latency",
	FONTPATH = "converter_fontpath",
	DEFAULT_FONT = "converter_default_font",
	OFFICE = "converter_office",
	SHAREPOINT = "converter_sharepoint",
	SHAREPOINT_URL = "converter_sharepoint_url",
	SHAREPOINT_USER = "converter_sharepoint_user",
	SHAREPOINT_PASSWORD = "converter_sharepoint_password",
	CHROMIUM = "converter_chromium",
	CHROMIUM_PORT = "converter_chromium_port"
}

export default WebserviceConverterFields;